<template>
    <div class="loading-animation">
        <lottie-animation
            :animationData="DEFAULT_LOADING_SPINNER"
            loop
            ref="loadingSpinner"
            :auto-play=false            
        />
    </div>
</template>
<script>
/**
 * @author Team Awesome
 */
import { LottieAnimation } from "lottie-web-vue";
import {DEFAULT_LOADING_SPINNER} from "@/constants";

export default {
    props: {
        light: { type: Boolean, default: false },
    },
    data() {
        return {
            DEFAULT_LOADING_SPINNER,          
        };
    },
    mounted() {        
        const localSpinner = this.$refs.loadingSpinner;
        setTimeout(function() { localSpinner.play(); }, 1500);
    },
    components: {
        LottieAnimation,
    },
};
</script>
<style scoped>
    .loading-animation * {
        stroke: var(--color__secondary)
    }
</style>
